import Vue from 'vue';
import copy from 'copy-to-clipboard';

Vue.prototype.$copy = copy;
